import { render, staticRenderFns } from "./RenewModal.vue?vue&type=template&id=563f03fd&"
import script from "./RenewModal.vue?vue&type=script&lang=js&"
export * from "./RenewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports